import { Vraag } from '../claims/vraag';

export class Meetgegevens {
    status: string;
    sleutel: string;
    reeks: Vraag[];
}
